var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6874 5.5V14.4375C17.6874 14.6198 17.615 14.7947 17.486 14.9236C17.3571 15.0526 17.1822 15.125 16.9999 15.125C16.8176 15.125 16.6427 15.0526 16.5138 14.9236C16.3848 14.7947 16.3124 14.6198 16.3124 14.4375V7.15945L6.4863 16.9864C6.3573 17.1154 6.18233 17.1879 5.99989 17.1879C5.81746 17.1879 5.64249 17.1154 5.51349 16.9864C5.38448 16.8574 5.31201 16.6824 5.31201 16.5C5.31201 16.3176 5.38448 16.1426 5.51349 16.0136L15.3404 6.1875H8.06239C7.88006 6.1875 7.70519 6.11507 7.57626 5.98614C7.44733 5.8572 7.37489 5.68234 7.37489 5.5C7.37489 5.31766 7.44733 5.1428 7.57626 5.01386C7.70519 4.88493 7.88006 4.8125 8.06239 4.8125H16.9999C17.1822 4.8125 17.3571 4.88493 17.486 5.01386C17.615 5.1428 17.6874 5.31766 17.6874 5.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/ArrowUpRight.8dd800920cf7b97374b9a8a045bf66ed.svg";
export { ForwardRef as ReactComponent };